"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
// import { QuoteReportBundle } from '@hudled/interfaces';
var Box_1 = __importDefault(require("@mui/material/Box"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
// import { useSubmitter } from 'utils/hooks';
var single_1 = require("utils/selectors/single");
var Report_1 = __importDefault(require("../Report"));
var ReportPaqe = function () {
    var _a;
    var reportBundledId = (0, react_router_dom_1.useParams)().reportBundledId;
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [{ collection: 'quote_report_bundles', doc: reportBundledId }]; });
    var location = (0, react_router_1.useLocation)();
    var queryParams = new URLSearchParams(location.search);
    var reportId = (_a = queryParams.get('rId')) !== null && _a !== void 0 ? _a : undefined;
    var selectQuoteReport = (0, react_1.useMemo)(function () { return (0, single_1.makeSelectQuoteReportByReportId)(reportId); }, [reportId]);
    var quoteReport = (0, react_redux_1.useSelector)(selectQuoteReport);
    if (!(0, react_redux_firebase_1.isLoaded)(quoteReport)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    if ((0, isEmpty_1.default)(quoteReport)) {
        return (0, jsx_runtime_1.jsx)("div", { children: "NOT FOUND" });
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Hudled - Quote Analyser", description: "Calculates and analyses a vendor quote, providing predictions of obtainable discounts for a set of plans" }), (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ height: "100%", width: "100%", component: "main", pb: { xs: 4, md: 8 } }, { children: (0, jsx_runtime_1.jsx)(Report_1.default, { quoteReport: quoteReport }) }))] }));
};
exports.default = ReportPaqe;
